import "./App.css";
import Home from "./pages/Home";
import { Navigate, Outlet, Route, Routes, useLocation } from "react-router-dom";
import CreateVote from "./pages/CreateVote";
import VotePage from "./pages/VotePage";
import Login from "./pages/Login";
import { Toaster } from "react-hot-toast";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./config/Firebase";
import { useEffect, useState } from "react";
import Profile from "./pages/Profile";
import Features from "./pages/Features";
import { useWindowSize } from 'react-use'
import Confetti from 'react-confetti'
import { useRecoilState, useRecoilValue } from "recoil";
import { firstVote } from "./Atom";

function App() {

  const { width, height } = useWindowSize()
  const [firstVoteCreated, setFirstVoteCreated] = useRecoilState(firstVote)
  const pathName  = useLocation()

  useEffect(() => {
  setTimeout(()=> {
    setFirstVoteCreated("false")
  },8000)
  },[pathName])
  
  return (
    <div className="App bg-gray-200 dark:bg-black font-Poppins">
      <Routes>
        <Route path="/login" element={<Login />} />
          <Route path="/" element={<Home />} />
        <Route element={<ProtectedRoute />}>
          <Route path="/create" element={<CreateVote />} />
          <Route path="/profile" element={<Profile />} />
        </Route>
        <Route path="/feature" element={<Features />} />
        <Route path="/Vote/:voteId" element={<VotePage />} />
      </Routes>
      <Toaster position="bottom-center" />
      {
      firstVoteCreated === "true" &&  <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', pointerEvents: 'none', zIndex: 9999 }}>
      <Confetti
        width={width}
        height={height}
        numberOfPieces={100}
      />
    </div>
      }
    </div>
  );
}

function ProtectedRoute() {
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user || null);
    });
    return () => unsubscribe();
  }, []);

  if (user === undefined) {
    // Optionally, show a loading spinner here
    return null;
  }

  return user ? <Outlet /> : <Navigate to="/login" replace />;
}

export default App;
